import styled from 'styled-components';

export const AccountHealthWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
